module.exports = __webpack_public_path__ + "img/winerackdog32.883429c3.jpg";